import { Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
    name: 'fromNow',
    standalone: false
})
export class FromNowPipe implements PipeTransform {
  public constructor(private readonly translateService: TranslateService) {

  }

  public transform(value: string): string {
    if (!value) {
      return ''
    }

    const diff = Date.now() - new Date(value).getTime()
    const seconds = Math.floor(diff / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 0) {
      return this.translateService.instant(`PIPES.FROM_NOW.${days > 1 ? 'DAYS' : 'DAY'}_AGO`, { days })
    }

    if (hours > 0) {
      return this.translateService.instant(`PIPES.FROM_NOW.${hours > 1 ? 'HOURS' : 'HOUR'}_AGO`, { hours })
    }

    if (minutes > 0) {
      return this.translateService.instant(`PIPES.FROM_NOW.${minutes > 1 ? 'MINUTES' : 'MINUTE'}_AGO`, { minutes })
    }

    return this.translateService.instant('PIPES.FROM_NOW.SECONDS_AGO')
  }
}
